import { Card as AntCard, CardProps } from 'antd';

// TODO: Remove me when antd is updated to version 5
const Card = ({ style, ...props }: CardProps) => {
  return <AntCard style={{ borderRadius: 8, ...style }} {...props} />;
};

export default Card;
